define('views/content/product_category',['require','views/base/item_page_view','text!templates/content/product_category.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');

    var temp = require("text!templates/content/product_category.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'product-page page',
        basePath: 'product-categories',
        titleKey: 'category',

        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'name': "required",
                    'code': "required"
                },
                messages: {
                    'name': App.polyglot.t('category_name_required'),
                    'code': App.polyglot.t('category_code_required')
                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        }
    });
});
